module.exports = __webpack_public_path__ + "static/media/Sero Bazaar old.829bb32e.png";